import { schema } from 'normalizr';

const cuisine = new schema.Entity('cuisine');

export default cuisine;
